// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"2227ed16","377":"5e467c01","453":"7668f3bd","523":"d338f4b8","636":"ac84eaaa","732":"e3b64224","817":"6ab46629","977":"529ff0a1","999":"a335b0fe"}[chunkId] + ".chunk.js";
};